import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseOrderFacade } from './purchase-order.facade';
import { PublicSignSession, PurchaseOrder } from '@models/resources/purchase-order.model';
import { environment } from '../../../../environments/environment';

/**
 * HTTP-Variante der Customer-Kaufauftrag-Actions (Sprint 9, ADR-011).
 */
@Injectable()
export class HttpPurchaseOrderFacade implements PurchaseOrderFacade {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/me/purchase-orders`;
  private readonly publicBase = `${environment.apiUrl}/sign`;

  get(id: number): Observable<PurchaseOrder> {
    return this.http.get<PurchaseOrder>(`${this.base}/${id}`);
  }

  chooseIdentityMethod(id: number, method: 'video' | 'post'): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(`${this.base}/${id}/identity-method`, {
      identity_method: method,
    });
  }

  uploadIdDocuments(id: number, front: File, back: File): Observable<PurchaseOrder> {
    const form = new FormData();
    form.append('front', front);
    form.append('back', back);
    return this.http.post<PurchaseOrder>(`${this.base}/${id}/id-documents`, form);
  }

  startSignature(id: number): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(`${this.base}/${id}/signature`, {});
  }

  submitSignature(id: number, png: Blob): Observable<PurchaseOrder> {
    const form = new FormData();
    form.append('signature', png, 'signature.png');
    return this.http.post<PurchaseOrder>(`${this.base}/${id}/signature/submit`, form);
  }

  requestSignLink(id: number): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(`${this.base}/${id}/signature/email`, {});
  }

  couponUrl(id: number): string {
    return `${this.base}/${id}/coupon`;
  }

  pdfUrl(id: number): string {
    return `${this.base}/${id}/pdf`;
  }

  getPublicSignSession(token: string): Observable<PublicSignSession> {
    return this.http.get<PublicSignSession>(`${this.publicBase}/${token}`);
  }

  publicSignPdf(token: string): Observable<Blob> {
    return this.http.get(`${this.publicBase}/${token}/pdf`, { responseType: 'blob' });
  }

  submitPublicSignature(token: string, png: Blob): Observable<PublicSignSession> {
    const form = new FormData();
    form.append('signature', png, 'signature.png');
    return this.http.post<PublicSignSession>(`${this.publicBase}/${token}`, form);
  }
}
